<template src="./AfiliacionForm.html"></template>
<style lang="scss" src="./AfiliacionForm.scss"></style>

<script>
import {
  Breadcrumb,
  BreadcrumbItem,
  Button,
  DatePicker,
  Divider,
  Form,
  FormItem,
  Input,
  Option,
  Select,
  Switch
} from 'element-ui'
import {requestAfiliacionMixin} from "@/api/ciudadano/afiliacionApi"
import {mapState} from "vuex"
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";
import {NotifyMixin} from "@/mixins/NotifyMixin";
import moment from 'moment-timezone'
import {utils} from "@/utils";
import {servelService} from "@/api/servelApi";

export default {
  name: "AfiliacionForm",
  mixins: [
    requestAfiliacionMixin,
    ScreenSizeMixin,
    NotifyMixin
  ],
  components: {
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [DatePicker.name]: DatePicker,
    [Button.name]: Button,
    [Option.name]: Option,
    [Select.name]: Select,
    [Input.name]: Input,
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem,
    [Switch.name]: Switch,
    [Divider.name]: Divider,
  },
  data() {
    const validateConfirmacionEmail = (rule, value, callback) => {
      this.$log.debug('validateConfirmacionEmail')
      if (value === '') {
        callback(new Error('El correo electrónico es obligatorio'));
      } else if (value !== this.model.email) {
        callback(new Error('El correo electrónico no coincide'));
      } else {
        callback();
      }
    };
    const validateAcepta = (rule, value, callback) => {
      this.$log.debug('validateAcepta')
      if (value === '' || value === false) {
        callback(new Error('Debe aceptar la Declaración'));
      } else {
        callback();
      }
    };
    const validateNumeroDocumento = (rule, value, callback) => {
      this.$log.debug('validateNumeroDocumento')
      if (!value) {
        callback(new Error('El número de documento es obligatorio'));
      } else if (!/^[A-Z0-9]{3}\.[A-Z0-9]{3}\.[A-Z0-9]{3}$/.test(value.toUpperCase())) {
        callback(new Error('El formato debe ser XXX.XXX.XXX (letras y/o números)'));
      } else {
        // Validar contra la API de Servel
        // Formatear el RUT: sin puntos pero con guión y dígito verificador
        const rutLimpio = utils.rutClean(this.model.rut)
        const rutFormateado = rutLimpio.substring(0, rutLimpio.length - 1) + '-' + rutLimpio.substring(rutLimpio.length - 1)
        // Número de documento sin puntos
        const nDocumentoLimpio = value.replace(/\./g, '')
        console.log('Validando cédula:', rutFormateado, nDocumentoLimpio)
        servelService.validarCedula(rutFormateado, nDocumentoLimpio)
          .then(response => {
            this.$log.debug('validarCedula response', response);
            if (response.data && response.data.statusCode === 200 && response.data.body && response.data.body.success) {
              const data = response.data.body.data;
              // Verificar que el documento esté vigente y no bloqueado
              if (data.validityStatus === 'VIGENTE' && data.status === 'NO BLOQUEADO') {
                this.isDocumentoValidado = true;
                callback();
              } else if (data.validityStatus !== 'VIGENTE') {
                this.isDocumentoValidado = false;
                callback(new Error('El documento no está vigente'));
              } else if (data.status !== 'NO BLOQUEADO') {
                this.isDocumentoValidado = false;
                callback(new Error('El documento está bloqueado'));
              } else {
                this.isDocumentoValidado = false;
                callback();
              }
            } else if (response.data && response.data.statusCode === 400) {
              this.isDocumentoValidado = false;
              callback(new Error('El número de documento no corresponde al RUT ingresado'));
            } else {
              this.isDocumentoValidado = false;
              callback(new Error('Error al validar el documento'));
            }
          })
          .catch(error => {
            this.$log.error('Error al validar cédula', error);
            this.isDocumentoValidado = false;
            if (error.response && error.response.data && error.response.data.statusCode === 400) {
              callback(new Error('El número de documento no corresponde al RUT ingresado'));
            } else {
              // Si hay error en la comunicación, no permitir continuar
              callback(new Error('Error de conexión al validar el documento. Intente nuevamente.'));
            }
          });
      }
    };
    return {
      errored: false,
      isAceptaValido: true,
      loading: true,
      usuarioDomicilio: null,
      listaPartidos: [],
      isDocumentoValidado: false,
      model: {
        rut: '',
        nombre: '',
        fechaNacimiento: '',
        domicilio: '',
        email: '',
        confirmacionEmail: '',
        telefonoMovil: '',
        telefonoFijo: '',
        partidosSeleccionado: '',
        ndocumento: '',
        acepta: false,
      },
      rules: {
        rut: [
          {
            length: 10,
            message: 'El RUT es obligatorio',
            trigger: 'blur'
          }
        ],
        nombre: [
          {
            min: 3,
            message: 'El nombre es obligatorio',
            trigger: 'blur'
          }
        ],
        fechaNacimiento: [
          {
            required: true,
            message: 'La fecha de nacimiento es obligatoria',
            trigger: 'blur'
          },
          {
            type: 'date',
            length: 10,
            message: 'La fecha de nacimiento es obligatoria',
            trigger: ['blur', 'change']
          }
        ],
        domicilio: [
          {
            min: 3,
            message: 'El domicilio es obligatorio',
            trigger: 'blur'
          }
        ],
        email: [
          {
            required: true,
            message: 'El correo electrónico es obligatorio',
            trigger: 'blur'
          },
          {
            type: 'email',
            message: 'Ingrese un correo electrónico válido',
            trigger: ['blur', 'change']

          }
        ],
        confirmacionEmail: [
          {
            required: true,
            message: 'El correo electrónico es obligatorio',
            trigger: 'blur'
          },
          {
            type: 'email',
            message: 'Ingrese un correo electrónico válido',
            trigger: ['blur', 'change']

          },
          {
            validator: validateConfirmacionEmail,
            trigger: 'blur'
          }
        ],
        partidosSeleccionado: [
          {
            required: true,
            message: 'Seleccione un Partido Político',
            trigger: 'blur'
          }
        ],
        acepta: [
          {
            required: true,
            message: 'Debe aceptar la Declaración',
            trigger: ['blur', 'change']
          },
          {
            validator: validateAcepta,
            trigger: ['blur', 'change']
          }
        ],
        ndocumento: [
          {
            required: true,
            message: 'El número de documento es obligatorio',
            trigger: 'blur'
          },
          {
            validator: validateNumeroDocumento,
            trigger: 'blur' // Solo validar al salir del campo para evitar múltiples llamadas a la API
          }
        ],
        // telefonoMovil: [
        //   {
        //     required: true,
        //     message: 'El Teléfono celular es obligatorio',
        //     trigger: 'blur'
        //   },
        //   {
        //     type: 'String',
        //     message: 'Ingrese un Teléfono celular válido',
        //     trigger: ['blur', 'change']

        //   }
        // ],
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      }
    }
  },
  beforeMount() {
    this.getUsuarioDomicilio()
    this.model.rut = this.user.current.rut
    this.model.nombre = this.user.current.nombreCompleto
    this.model.fechaNacimiento = this.user.current.fechaNacimiento
  },
  computed: {
    ...mapState({
      user: state => state.user,
    }),
    isValidFechaNacimiento: function () {
      if (this.user.current.fechaNacimiento)
        return moment(this.user.current.fechaNacimiento, 'DD-MM-YYYY').isValid()
      return false
    },
  },
  methods: {
    goBack() {
      this.$emit('on-back')
    },
    validate() {
      this.$refs['afiliacionForm']
        .validate((valid) => {
          if (valid) {
            // Verificar que el documento esté validado
            if (!this.isDocumentoValidado) {
              this.showError('Debe validar el número de documento antes de enviar el formulario')
              return
            }
            this.$log.debug("enviando...")
            const loading = this.getLoading()

            // Validar cédula antes de enviar
            // Formatear el RUT: sin puntos pero con guión y dígito verificador
            const rutLimpio = utils.rutClean(this.model.rut)
            const rutFormateado = rutLimpio.substring(0, rutLimpio.length - 1) + '-' + rutLimpio.substring(rutLimpio.length - 1)
            // Número de documento sin puntos
            const nDocumentoLimpio = this.model.ndocumento.replace(/\./g, '')
            servelService.validarCedula(rutFormateado, nDocumentoLimpio)
              .then(validacionResponse => {
                this.$log.debug('Validación cédula response', validacionResponse)

                // Verificar estructura de respuesta exitosa
                if (!validacionResponse.data ||
                    validacionResponse.data.statusCode !== 200 ||
                    !validacionResponse.data.body ||
                    !validacionResponse.data.body.success) {
                  loading.close()
                  const errorMsg = validacionResponse.data?.body?.error || 'El número de documento no es válido'
                  this.showError(errorMsg)
                  return
                }

                // Verificar que el documento esté vigente y no bloqueado
                const data = validacionResponse.data.body.data
                if (data.validityStatus !== 'VIGENTE') {
                  loading.close()
                  this.showError('El documento no está vigente')
                  return
                }

                if (data.status !== 'NO BLOQUEADO') {
                  loading.close()
                  this.showError('El documento está bloqueado')
                  return
                }

                // Si la validación es exitosa, continuar con el envío
                return this.enviarSolicitudCiudadano(loading)
                  .then(response => {
                    this.$log.debug('enviarSolicitudCiudadano', response)

                    let partidoFound = this.listaPartidos
                      .find(x => x.partido_id === this.model.partidosSeleccionado)
                    if (partidoFound) {
                      const partidoSelecionado = partidoFound.partido_nombre
                      this.$emit('on-created', valid, partidoSelecionado, response)
                    }
                    loading.close()
                  })
              })
              .catch(err => {
                this.$log.error('Error al validar documento', err)
                if (err.response && err.response.data && err.response.data.statusCode === 400) {
                  const errorMsg = err.response.data.body?.error || 'El número de documento no es válido'
                  this.showError(errorMsg)
                } else {
                  this.showError('Ocurrió un error inesperado al enviar la solicitud')
                }
                loading.close()
              })

          } else {
            this.$log.debug('error submit!!')
          }
        })
    },
    getDataFromPartidoSeleccionado(data = {}) {
      const partidoFound = this.listaPartidos
        .find(x => x.partido_id === this.model.partidosSeleccionado)
      if (partidoFound) {
        data.partido_id = partidoFound.partido_id
        data.partido_sigla = partidoFound.partido_sigla
        data.partido_nombre = partidoFound.partido_nombre
        data.estado_glosa = partidoFound.estado_glosa
        data.partido_cod_region = this.usuarioDomicilio.numero_region.toString()
        data.partido_email = partidoFound.email
      }
    },
    getDataFromModelForm(data = {}) {
      data.materno = this.$store.state.user.current.materno
      data.nombres = this.$store.state.user.current.nombres
      data.paterno = this.$store.state.user.current.paterno
      data.fecha_nacimiento = this.model.fechaNacimiento
      data.email = this.model.email
      data.telefono_fijo = this.model.telefonoFijo
      data.telefono_movil = this.model.telefonoMovil
      data.ndocumento = this.model.ndocumento
    },
    getDataFromDomicilio(data = {}) {
      data.calle = this.usuarioDomicilio.calle
      data.comuna = this.usuarioDomicilio.nombre_comuna
      data.region = this.usuarioDomicilio.nombre_region
      data.numero = this.usuarioDomicilio.numero
      data.pais = this.usuarioDomicilio.glosa_pais
    },
    generarData() {
      let data = {}

      this.getDataFromPartidoSeleccionado(data)
      this.getDataFromModelForm(data)
      this.getDataFromDomicilio(data)

      return data;
    },
    enviarSolicitudCiudadano(loading) {
      let data = this.generarData();
      this.$log.debug('enviarSolicitudCiudadano', data)

      return this.enviarAfilicacion(data)
        .then(response => {
          this.$log.debug('enviarAfilicacion', response.data.statusCode)

          loading.close();
          if (response.data.statusCode === 201) {
            return true
          } else {
            this.showError('Ocurrió un error inesperado al enviar la afiliación')
            return false
          }
        })
        .catch(err => {
          this.$log.fatal('enviarAfilicacion', err, err.response, err.request)

          loading.close()
          this.showError('Ocurrió un error inesperado al enviar la afiliación')
          return false
        })
    },
    getUsuarioDomicilio() {
      servelService.getRegistrodomicilio()
        .then(response => {
          this.$log.debug('getRegistrodomicilio', response.data)

          if (response.data.statusCode === 200) {
            const data = response.data.datos;
            this.$log.debug(data)
            this.usuarioDomicilio = data;

            this.model.domicilio = utils.capitalize(
              `${data.calle}, ` +
              `${data.numero}, ` +
              `${data.nombre_comuna}, ` +
              `${data.nombre_region}`)

            this.getListaPartidos()
          } else {
            this.errored = true
            this.showError('Ocurrió un error inesperado al cargar los datos del domicilio')
          }
        })
        .catch(err => {
          this.$log.fatal('getRegistrodomicilio', err, err.response, err.request)
          this.errored = true
          this.showError('Ocurrió un error inesperado al cargar los datos del domicilio')
        })
    },
    getListaPartidos() {
      this.getListaPoliticanPartyByRegion(this.usuarioDomicilio.numero_region)
        .then(response => {
          this.$log.debug('getListaPoliticanPartyByRegion', response.data.statusCode, response.data.datos)

          const data = JSON.parse(response.data.datos)

          this.listaPartidos = data
            .sort((a, b) => a.partido_nombre.localeCompare(b.partido_nombre))
          this.loading = false
        })
        .catch(err => {
          this.$log.fatal('getListaPoliticanPartyByRegion', err)
          this.loading = false
          this.errored = true
          this.showError('Ocurrió un error inesperado al cargar los datos')
        });
    },
    politicalPartyChange(item) {
      this.$log.debug(item)

      const it = this.listaPartidos.find(x => x.partido_id === item)
      if (it != null && it.pending) {
        this.showWarn('Partido pendiente de informar la persona designada para comunicar solicitudes')

        this.model.partidosSeleccionado = ''
      }
    },
    formatNumeroDocumento(value) {
      // Resetear estado de validación cuando se modifica el campo
      this.isDocumentoValidado = false;
      
      // Convertir a mayúsculas y eliminar caracteres no alfanuméricos excepto puntos
      let cleaned = value.toUpperCase().replace(/[^A-Z0-9.]/g, '');

      // Eliminar puntos para reformatear
      cleaned = cleaned.replace(/\./g, '');

      // Limitar a 9 caracteres alfanuméricos
      cleaned = cleaned.substring(0, 9);

      // Formatear con puntos cada 3 caracteres
      let formatted = '';
      if (cleaned.length > 0) {
        formatted = cleaned.substring(0, 3);
        if (cleaned.length > 3) {
          formatted += '.' + cleaned.substring(3, 6);
        }
        if (cleaned.length > 6) {
          formatted += '.' + cleaned.substring(6, 9);
        }
      }

      // Actualizar el modelo
      this.model.ndocumento = formatted;
    }
  }
}

</script>


